export default __webpack_public_path__ + "static/media/rocket.2eece058.png";